import React, { FC } from 'react';
import { Button } from '../../kit';
import { c } from '../../lib/util';
import styles from './styles.module.scss';

interface ChangeHandlerProps {
    cancelBtnLabel?: string,
    changesMade: boolean,
    onCancel?: () => void,
    onSave: () => void,
    saveBtnLabel?: string,
}

const ChangeHandler: FC<ChangeHandlerProps> = ({
    cancelBtnLabel,
    changesMade,
    onCancel,
    onSave,
    saveBtnLabel
}): JSX.Element => {
    return (
        <div
            className={c([
                styles.base,
                changesMade && styles.show,
            ])}
        >
            <p>
                Niet opgeslagen wijzigingen
            </p>
            <Button
                color="white"
                label={cancelBtnLabel || 'Annuleren'}
                onClick={onCancel}
            />
            <Button
                color="primary"
                label={saveBtnLabel || 'Opslaan'}
                onClick={onSave}
            />
        </div>
    );
}

export default ChangeHandler;
